import { CompraVendaResumoResponse, OperacaoCommonStatus } from 'common/genericTypes';

const estaPreenchido = (texto?: string): boolean => typeof texto === 'string' && texto.trim().length > 0;

export const isCompromissadaEntreCustodiantes = (item: CompraVendaResumoResponse): boolean =>
  estaPreenchido(item.custodianteOrigem) &&
  estaPreenchido(item.custodianteDestino) &&
  item.custodianteOrigem !== item.custodianteDestino;

export const lancadorNaoPodeAprovarCompromissada = (
  item: CompraVendaResumoResponse,
  participanteIdLogado?: string
): boolean =>
  isCompromissadaEntreCustodiantes(item) &&
  estaPreenchido(participanteIdLogado) &&
  item.participanteOrigemId === participanteIdLogado;

export const podeAprovarCompromissada = (item: CompraVendaResumoResponse, participanteIdLogado?: string): boolean =>
  item.status === OperacaoCommonStatus.EmAnalise && !lancadorNaoPodeAprovarCompromissada(item, participanteIdLogado);
